import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { AppOptionType, OptionType } from "../../../features/manageHomepage/ManageHomePageTypes";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import './studioRoleSelectionAndSavePopupModal.css'
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const RolesSelectionPopup: React.FC<{
    appType: AppOptionType;
    selectedRoles: OptionType[];
    setSelectedRoles: (roles: OptionType[]) => void;
    onSave: () => void;
    onCancel: () => void;
  }> = ({
    appType,
    selectedRoles,
    setSelectedRoles,
    onSave,
    onCancel,
  }) => {
    return (
      <div className="studio-role-selection-and-save-popup">
        <div className="studio-role-selection-and-save-popup-backdrop" onClick={onCancel} />
        <div className="studio-role-selection-and-save-popup-content">
          {appType.designations.length > 1 && (
            <div>
              <h3>Would you like to clone this config to other designations as well ?</h3>
              <p className="studio-role-selection-and-save-popup-warning">
                Warning! This will override the old config and clone the new values to them.
              </p>
              <Autocomplete
                multiple
                options={appType.designations}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                disableCloseOnSelect
                value={selectedRoles}
                onChange={(e, newValue : OptionType[]) => {
                  const filteredValue = newValue.filter((role) => role.id !== selectedRoles[0].id)
                  // make sure that the initial role is always selected 
                    setSelectedRoles(
                        [selectedRoles[0], ...filteredValue]
                    );
                }}
                getOptionDisabled={(option) => option.id === selectedRoles[0].id}
                renderOption={(props, option, { selected }) => {
                  const { ...rest } = props;
                  return (
                    <li {...rest}> 
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.label}
                  </li>
                )}}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Roles"
                    placeholder="Choose..."
                    style={{ width: '100%' }}
                  />
                )}
              />
            </div>
          )}
          <div className="studio-role-selection-and-save-popup-button-container">
            <button className="studio-role-selection-and-save-popup-button" onClick={onSave}>Save</button>
            <button className="studio-role-selection-and-save-popup-button" onClick={onCancel}>Cancel</button>
          </div>
        </div>
      </div>
    );
  };